import styles from '../cart/cart-page.module.scss'
import stylesCheckout from './checkout.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { Button, Input, PageContainer } from '@touche-lts/panel-ui/dist'
import { IconCart, IconShipping, IconPayment, IconAccount } from 'assets/icons'
import { useEffect, useState } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { AccountAddress } from 'pages'
import { CredicCardsDTO } from 'models'
import { CheckboxButton } from "pages/store/view-store-page/store-shippings-sections/shipping-option/shipping-option-edit/checkbox-button"

const CheckoutComponent = () => {

  const {
    cartCheckoutStore: {
      getCartByUserId,
      cartStoreProducts,
      deleteCartByProductId,
      updateCartByProductId,
      orderSummary,
      cartStoreSelectedProducts,
      changeCollpaseStateCheckoutStore,
      selectPaymentDetails,
      confirmAndPayRestrict,
      confirmAndPay,
      newCreditCardDetails,
      setNewCreditCardDetails,
      isNewCardPaymentOptionSelected,
      isSaved,
      switchSaveNewCard,
      creditCardFormEnabled,
      setCreditCardFormEnabled,
      isNewCard,
      setIsNewCard,
      isShopifyOnlyCheckout,
      isAllProductValidForShopifyCheckout
    },
    accountStore: {
      getUserById,
      accountDetails,
      getCreditCards,
      creditCardsDetails,
      setAccountStoreProps
    },
    routingStore: { push }
  } = useRootStore(),
    userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id,

    handleColorCheck = (color: string): boolean => {
      return color.startsWith('#') && color.length <= 9
    },

    isImageUrlAVideo = (imageUrl: string): boolean => {
      if (!!imageUrl) {
        return imageUrl.includes('.mp4')
      }
      return false;
    },

    handleDeleteProduct = (productId: string | number): void => {
      deleteCartByProductId(userDetailsId, productId)
    },

    handleCountAddPlus = (productDetails: any): void => {
      productDetails.count++;
      updateCartByProductId(userDetailsId, productDetails)
    },

    handleCountAddMinus = (productDetails: any): void => {
      if (productDetails.count > 1) {
        productDetails.count--;
        updateCartByProductId(userDetailsId, productDetails)
      }
    }
  // Redirect to login if not loggedin
  if (!userDetailsId) {
    push('/login')
  }


  const handleRatioCartSelect = (e, isNewCard:boolean, card?:any) => {
    const { value } = e.target;

    if(isNewCard===false){
    selectPaymentDetails(value)
    setCreditCardFormEnabled(false)
    setNewCreditCardDetails(card)
    } else {
    setIsNewCard(isNewCard)
    setCreditCardFormEnabled(true)
    setNewCreditCardDetails({
      number: "",
      expDate: "",
      id: "",
      externalId: "",
      name: "",
      scv:"",
      cardType: null
  })
    }
  }

  useEffect(() => {
    getUserById(userDetailsId)
    getCreditCards(userDetailsId)
    getCartByUserId(userDetailsId)
  }, [getCartByUserId, getUserById, getCreditCards, userDetailsId])

  return (
    <PageContainer className={cl(styles.scrollable, 'container')} style={{ marginTop: 80 }}>
      <div className="row">
        <div className="col-lg-7">
          <h2 className={stylesCheckout.productsHeader}>
            <IconAccount /> &nbsp;Personal information
          </h2>
          <div className={styles.shoppingCartBox}>
            <div className="row">
              <div className="col-lg-6">
                <Input
                  colorPreset='dark'
                  placeholder='First name'
                  value={accountDetails?.firstName}
                  className={cl(stylesCheckout.input, 'mb-3')}
                  onChange={firstName => setAccountStoreProps({ firstName })}
                />
                <Input
                  colorPreset='dark'
                  placeholder='Email'
                  value={accountDetails?.emailAddress}
                  className={cl(stylesCheckout.input, 'mb-3')}
                  onChange={emailAddress => setAccountStoreProps({ emailAddress })}
                />
              </div>
              <div className="col-lg-6">
                <Input
                  colorPreset='dark'
                  placeholder='Last name'
                  value={accountDetails?.lastName}
                  className={cl(stylesCheckout.input, 'mb-3')}
                  onChange={lastName => setAccountStoreProps({ lastName })}
                />
                <Input
                  colorPreset='dark'
                  placeholder='Phone number'
                  value={accountDetails?.phoneNumber}
                  className={cl(stylesCheckout.input, 'mb-3')}
                  onChange={phoneNumber => setAccountStoreProps({ phoneNumber })}
                />
              </div>
            </div>
          </div>
          <AccountAddress key='address-checkout' style={{ margin: 0, padding: 0 }} />
          {!isShopifyOnlyCheckout && (
          <>
          <div className='d-flex'>
            <h2 className={stylesCheckout.productsHeader}>
              <IconPayment /> &nbsp;Payment details
            </h2>
            {/* {!creditCardFormEnabled && <div className={stylesCheckout.addNewCreditCard} onClick={() => setCreditCardFormEnabled(true)}>
              <span>+</span>
              <p>New Credit or Debit card</p>
            </div>} */}
          </div>
          <div className={styles.shoppingCartBox}>
     
            {creditCardsDetails && creditCardsDetails.map((card: CredicCardsDTO) => {
              return (
                <div className={stylesCheckout.paymentSelected}>
                  <input
                    type="radio"
                    id="cart_selected"
                    name="cart_selected"
                    checked={newCreditCardDetails?.id === card.id}
                    value={card?.id}
                    onChange={ev => handleRatioCartSelect(ev,false, card)}
                  />
                  <span className={stylesCheckout.paymentSelected}>{card?.name + ' ' + card?.number}</span>
                </div>
              )
            })}

            <div className={stylesCheckout.paymentSelected}>
                  <input
                    type="radio"
                    id="new_card"
                    name="new_card"
                    value={newCreditCardDetails?.id}
                    checked={isNewCardPaymentOptionSelected}
                    onChange={ev => handleRatioCartSelect(ev, true)}
                  />
                  <span className={stylesCheckout.paymentSelected}>New Credit or Debit card</span>
                </div>

                {creditCardFormEnabled && isNewCard &&
              <>
                <div className="col-md-6">
                  <Input colorPreset='dark' placeholder='Card number' className='mb-3' value={newCreditCardDetails?.number}
                    onChange={(number) => setNewCreditCardDetails({ ...newCreditCardDetails, number })} />
                </div>
                <div className="col-md-6 d-flex">
                  <Input colorPreset='dark' placeholder='Valid thru mmYY' className='mb-3' value={newCreditCardDetails?.expDate}
                    onChange={(expDate) => setNewCreditCardDetails({ ...newCreditCardDetails, expDate })} />
                  <span style={{ marginLeft: 8, marginRight: 8 }} />
                  <Input colorPreset='dark' placeholder='CVV' className='mb-3' value={newCreditCardDetails?.scv}
                    onChange={(scv) => setNewCreditCardDetails({ ...newCreditCardDetails, scv })} />
                </div>
                <div className="col-md-6">
                  <Input colorPreset='dark' placeholder='Name on card' className='mb-3' value={newCreditCardDetails?.name}
                    onChange={(name) => setNewCreditCardDetails({ ...newCreditCardDetails, name })} />
                </div>
                <CheckboxButton
                label="Save card for future orders"
                className={styles.fieldSaveCard}
                onClick={switchSaveNewCard} 
                checkboxProps={{isChecked:isSaved}}
                 />

                {/* <div className="col-md-6 d-flex" style={{ justifyContent: "space-between" }}>
                  <Button preset='secondary' colorPreset='dark' className='mb-3 col-md-3' onClick={() => setCreditCardFormEnabled(false)}>Cancel</ Button>
                  <Button preset='primary' colorPreset='dark' className='mb-3 col-md-8'
                    onClick={() => {
                      addCreditCard(JSON.parse(localStorage.getItem('userDetails'))?.id as number, newCreditCard)
                      setCreditCardFormEnabled(false)
                    }}>Add</Button>
                </div> */}
              </>
            }
          </div>
          </>
          )}
          {isShopifyOnlyCheckout && (
            <div className={styles.shoppingCartBox}>
              <p className={stylesCheckout.shopifyCheckoutNotice}>
                This order contains Shopify products. You will be redirected to the Shopify store to complete payment.
              </p>
            </div>
          )}
          <h2 className={stylesCheckout.productsHeader}>
            <IconShipping /> &nbsp;Items and postage
          </h2>
          {cartStoreSelectedProducts && !!Object.keys(cartStoreSelectedProducts).length && Object.keys(cartStoreSelectedProducts)
            .reverse()
            .map(storeName => {
              const isShopifyProduct = cartStoreSelectedProducts[storeName]?.storeProducts?.[0]?.product?.shopifyId;
              return (
                <div className={styles.shoppingCartBox}>
                  <div className={stylesCheckout.storeHeader}>
                    <p>{storeName}</p>
                    {isShopifyProduct ? (
                      <span className={styles.shopifyProductBadge}>Shopify Product</span>
                    ) : null}
                    <div className={stylesCheckout.storeInfo}>
                      <strong>{cartStoreSelectedProducts[storeName]?.products} products</strong>
                      <p> ({cartStoreSelectedProducts[storeName]?.items} items)</p>
                      <span onClick={() => changeCollpaseStateCheckoutStore(storeName)}>
                        {!cartStoreSelectedProducts[storeName]?.collapsed ? '+' : '-'}
                      </span>
                    </div>
                  </div>
                  <hr />
                  {cartStoreSelectedProducts[storeName]?.collapsed && cartStoreSelectedProducts[storeName].storeProducts.map((productDetails, indexDetails) => {
                    return (
                      <div className="row">
                        <div className="col-lg-3">
                          <div className={styles.storeProductCheckboxImage}>
                            {productDetails?.product?.images && !!productDetails?.product?.images.length && (
                              isImageUrlAVideo(productDetails?.product?.images[0]?.url) ?
                                <video>
                                  <source src={productDetails?.product?.images[0]?.url} />
                                </video> :
                                <img src={productDetails?.product?.images[0]?.url} alt="Product Details" />
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <h4 className={styles.productHeader}>
                            {productDetails?.product?.name}
                          </h4>
                          <p className={styles.productPrice}>
                            {productDetails?.sku?.curr} {productDetails?.price}
                          </p>
                          {productDetails?.sku?.attributes && productDetails?.sku?.attributes.map(attr => {
                            return (
                              <p className={styles.productAttributes}>
                                {attr?.name}: {handleColorCheck(attr?.value)
                                  ? <span className={styles.dotDynamic} style={{ backgroundColor: attr?.value }}></span> : attr?.value}
                              </p>
                            )
                          })}
                          <div className={styles.shippingProductSelect}>
                            <p>Shipping</p>
                            <p className="my-3">{productDetails?.shipping?.name} - {productDetails?.shipping?.currency} {productDetails?.shipping?.price}</p>
                            {/* <select className={cl(styles.selectShipping, dropDownIndicatorStyle)}>
                                {productDetails?.product?.shippings.map((shipping, indexShipping) => {
                                  return (
                                    <>
                                      {indexShipping === 0 && (
                                        <option selected value={shipping?.id}>{shipping?.name} - {shipping?.currency} {shipping?.price}</option>
                                      )}
                                      {indexShipping > 0 && (
                                        <option value={shipping?.id}>{shipping?.name} - {shipping?.currency} {shipping?.price}</option>
                                      )}
                                    </>
                                  )
                                })}
                              </select> */}
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="d-flex flex-column align-items-end">
                            <div className={styles.quantityCount}>
                              <span onClick={() => handleCountAddMinus(productDetails)}>-</span>
                              <p className={styles.quantity}>{productDetails?.count}</p>
                              <span className={productDetails?.sku?.stock <= 1 ? styles.disableBehavior : ''} onClick={() => handleCountAddPlus(productDetails)}>+</span>
                            </div>
                            <p onClick={() => handleDeleteProduct(productDetails?.id)} className={styles.removeItem}>Remove item</p>
                            <p className={styles.skuInfo}>SKU: {productDetails?.sku?.sku}</p>
                          </div>
                        </div>
                        {cartStoreProducts[storeName].length > 1 && indexDetails <= cartStoreProducts[storeName].length - 2 &&
                          (<hr style={{ color: 'white', margin: '10px 0px' }} />)}
                      </div>
                    )
                  })}
                  {cartStoreSelectedProducts[storeName]?.collapsed && (<hr />)}
                  <div className={stylesCheckout.storeInfoNoCollapse}>
                    <p>Subtotal:</p>
                    <p>US ${cartStoreSelectedProducts[storeName]?.subtotal}</p>
                  </div>
                  <div className={stylesCheckout.storeInfoNoCollapse}>
                    <p>Shipping fee:</p>
                    <p>US ${cartStoreSelectedProducts[storeName]?.shippingfee}</p>
                  </div>
                  <div className={stylesCheckout.storeInfoNoCollapse}>
                    <h4>Total:</h4>
                    <h4>US ${cartStoreSelectedProducts[storeName]?.total}</h4>
                  </div>
                </div>
              )
            })}
        </div>
        <div className="col-lg-5">
          <div className="d-flex">
            <IconCart style={{ fill: 'white' }} />
            <h4 className={styles.orderSummaryHeader}>Order summary</h4>
          </div>
          <div className={styles.orderSummaryBox}>
            <div className={styles.orderSummaryContent}>
              <p>Items ({orderSummary.items})</p>
              <p>US ${orderSummary.itemsTotal}</p>
            </div>
            <div className={styles.orderSummaryContent}>
              <p>Shipping fee</p>
              <p>US ${orderSummary.shippingFee}</p>
            </div>
            <hr />
            <div className={styles.orderSummaryContentTotal}>
              <p>Total to pay</p>
              <p>US ${orderSummary.totalToPay}</p>
            </div>
            <Button
              className={cl(styles.proceedToCheckOutBtn,
                 (orderSummary.items === 0 || !confirmAndPayRestrict || !isAllProductValidForShopifyCheckout) ?
                  styles.disableBehavior : '')}
              preset='primary'
              onClick={() => confirmAndPay(userDetailsId)}>
              {isShopifyOnlyCheckout ? 'Continue to Shopify' : 'Confirm and pay'}
            </Button>
          </div>
        </div>
      </div>
    </PageContainer>
  )
},

  CheckoutPage = observer(CheckoutComponent)
export { CheckoutPage }
